import config from 'cityads-v3/config';
import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  GET_CHANNELS,
  GET_CHANNELS_SUCCESS,
  GET_CHANNELS_FAIL,
} from "../actions/channels";

const debugData = {
  trafficChannel: [
    {
      id: 1,
      wm_id: 'azaza',
      name: 'Канал 1'
    }, {
      id: 2,
      wm_id: 'lolkek',
      name: 'Канал 2'
    }
  ]
};

const initialState = {
  channelIds: [],
  channelsById: {},
  channelsByWmId: {},
  isLoading: false,
  isLoaded: false,
};

export default function channels(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CHANNELS:
      return {
        ...state,
        isLoading: true,
      }

    case GET_CHANNELS_SUCCESS:
      const trafficChannel = action.response.trafficChannel.map(item => ({
        ...item,
        id: +item.id
      }))
      return {
        ...state,
        channelIds: mapIds(trafficChannel).sort((a,b) => a - b),
        channelsById: {
          ...state.channelsById,
          ...mapObjectize(trafficChannel),
        },
        isLoading: false,
        isLoaded: true,
      }

    case GET_CHANNELS_FAIL:
      return {
        ...state,
        channelIds: mapIds(config.DEBUG ? debugData.trafficChannel : []),
        channelsById: {
          ...state.channelsById,
          ...mapObjectize(config.DEBUG ? debugData.trafficChannel : []),
        },
        isLoading: false,
        isLoaded: false,
      }

    default:
      return state;
  }
}
